import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const fetcher = () =>
  TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.MONEDA).then(
    ({ data }) => data
  )

const MonedaSelect = props => {
  const { data: moneda } = useSwr('select_monedas', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {moneda.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(MonedaSelect)
